import { catchError as rxjscatchError, map as rxjsmap, throwError as rxjsthrowError } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UploadInput } from '../_models/primeng-uploads';
import { Observable, Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class FileUploadService {
    private subscription: Subscription;
    public static get headerOption() {
        let headers = new HttpHeaders();
        let options = { headers: headers }
        return options;
    }

    constructor(private http: HttpClient) { }

    uploadBusinessFile(formData:any): UploadInput {
        let uploadInput: UploadInput = {
            type: 'uploadAll',
            url: environment.BASE_URL + '/file/upload/business/manual',
            method: 'POST',
            data: {
                FolderTypeName: formData.folderTypeName,
                ApplicationId: formData.applicationId,
                BusinessId: formData.businessId,
                FeatureId: formData.featureId
            }
        };

        return uploadInput;
    }

    uploadAdminFile(formData) {
        let result: any = this.http
            .post(
                environment.BASE_URL + '/file/upload/application/manual',
                formData
            ).pipe(rxjsmap(result => result)).pipe(rxjscatchError((error:any) => rxjsthrowError(error)))
            .subscribe(
            );
        this.subscription = result;
        return result;
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
